import { IAppFrom } from "../interfaces/IAppFrom";
export const prioritizeInAppPurchase = (from) => {
    if (from == IAppFrom.REMINDS || from == IAppFrom.KEEPASS || from == IAppFrom.CALENDAR) {
        return true;
    }
    return false;
};
